<template lang="pug">
	component.detail-promo(
		v-if="visible",
		:class="`detail-promo--${version}`"
		:is="promotion.URL.length ? 'a' : 'div'",
		:href="promotion.URL.length ? promotion.URL : false",
		:target="promotion.URL.length ? '_blank' : false")
		span.detail-promoText(
			v-if="!image && promotion.Text.length",
			v-html="promotion.Text", 
			:style="styles.primary.color")
		img.detail-promoImage(
			v-else-if="image", 
			:src="image",
			:alt="alt")
</template>

<script>
import Media from "@/listing-app/mixins/Media";
import Theme from "@/listing-app/mixins/Theme";
export default {
  name: "Promo",
  mixins: [Media, Theme],
  props: ["promotion", "version"],
  data() {
    return {};
  },
  computed: {
    visible() {
      if (this.promotion) {
        if (this.version == "mobile") {
          if (this.breakpoint == "lg" || this.breakpoint == "xl") {
            return false;
          }
          return true;
        }
        if (this.breakpoint == "lg" || this.breakpoint == "xl") {
          return true;
        }
        return false;
			}
			return false;
    },
    image() {
      if (this.breakpoint == "lg" || this.breakpoint == "xl") {
        return this.promotion.ImageDesktop;
      }
      return this.promotion.ImageMobile;
    },
    alt() {
      if (this.breakpoint == "lg" || this.breakpoint == "xl") {
        return this.promotion.ImageAltDesktop;
      }
      return this.promotion.ImageAltMobile;
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-promo {
  margin-bottom: 30px;
  padding: 10px;
  border: 1px solid $gray;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  font-weight: bold;
  color: currentColor;
  * {
    max-width: 100%;
    max-height: 100%;
  }
  &:empty {
    display: none;
  }
}

.detail-promo.detail-promo--desktop {
  flex: 1 1 auto;
  margin-bottom: 0;
  height: 100%;
}

a.detail-promo {
  transition: box-shadow 0.25s ease;
  text-decoration: none;
  &:hover {
    box-shadow: 0 0 10px rgba($black, 0.15), 0 0 40px rgba($black, 0.05);
  }
}

.detail-promoText,
.detail-promoImage {
  width: 100%;
  text-align: center;
}
</style>
